$(function(){

    // home slider scroll
    var offset = 0;
    var autoscrolling = false;
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var page = $('html, body');

    var target = $('.i4-site__content');

    // scroll down with wheel
    var slider = $('.i4-site__slider');
    if (slider.length) {
        window.onwheel = function (e) {
            scrollToContent(target, false);
        };
    }

    // scroll down on caret click
    var scrolldown = $('#scrolldown');
    if (scrolldown.length) {
        scrolldown.on('click', function () {
            scrollToContent(target, true);
        });
    }

    // function with controlled scroll down to target
    var scrollToContent = function (target, clicked) {
        if (target.length) {

            // do not use any auto-scrolling in edit mode
            if ($('body.i4-template--edit-mode').length) {
                return;
            }

            var targetPos = target.offset().top + offset;
            var currentPos = window.pageYOffset || document.documentElement.scrollTop || 0;
            // 1: we are scrolling downwards, 2: current scroll pos is lower than beginning of target pos
            if (clicked || (currentPos > lastScrollTop && currentPos < targetPos)) {
                if (!autoscrolling) {
                    autoscrolling = true;
                    page.animate({
                        scrollTop: targetPos
                    }, 500, 'swing', function () {
                        autoscrolling = false;
                        lastScrollTop = currentPos;
                    });
                }
            } else {
                lastScrollTop = currentPos;
            }
        }
    };


});

